import http from '@/communication/AuthConnection'
import Store from '@/state'

export default async (socket, { message }) => {
  const reviewInfo = {
    quoteId: Store.getters['ItemAssociation/GET_ITEM_SELECTED_ID'],
    username: Store.getters['Login/GET_USERNAME'],
    message
  }
  const eventPayload = await http.post(`/v1/item-association/message`, reviewInfo)
  Store.commit('ItemAssociation/FILL_MESSAGE')

  return Promise.resolve(eventPayload)
}



// WEBPACK FOOTER //
// ./src/brain/item-association/NewReview.js